import { NoDataFound } from '../../assets';
const NoDataFoundComponent = ({ text, image, height }: { text?: string, image?: string, height?: number }) => {
    return (
        <>
            <div className="table-wrap position-relative text-center d-flex justify-content-center align-items-center"
                style={{ minHeight: height ? `${height}px` : '49vh' }}>
                <div className="">
                    <div className="text-center">
                        <img
                            src={image || NoDataFound}
                            alt=""
                            width={110}
                            className="mb-3"
                            style={{ backgroundColor: 'transparent' }}
                        />
                        <h3 className="text-secondary font-12">
                            {text ? text : `No Record Found`}
                        </h3>
                    </div>
                </div>
            </div>
        </>
    )
};
export default NoDataFoundComponent;